import React, { Component } from "react";

class Video extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div
        className="video-area tp-video-area"
        style={{
          backgroundImage: "url(" + publicUrl + "assets/img/bg/20.png)",
          paddingTop: "50px",
          paddingBottom: "80px",
        }}
      >
        <div className="container go-top">
          <div className="row">
            <div
              className="col-xl-5 col-lg-6 align-self-center wow animated fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <div className="section-title mb-lg-0 mb-4 text-center text-lg-left">
                <h2 className="title">
                  Zašto odabrati <br /> Prokurator?
                </h2>
                <p>
                  Digitalni marketing i vanjsko oglašavanje rade ravnopravno:
                  SEO, Google Ads i društvene mreže pokazuju tko vas vidi i što
                  klikne, a ploha na cesti gradi svijest 24 sata dnevno.
                </p>
                <hr />
                <p>
                  Ista poruka na Googleu, Instagramu i u prometu. Billboardi i
                  city lightovi nisu dodatak kampanji — jednako su važni kao
                  online kanali. Sve iz jednog tima u Splitu.
                </p>
                <hr />
                <p>
                  Radimo za klijente diljem Hrvatske. Od ključnih riječi i web
                  stranice do plohe u Splitu, Zadru ili Rijeci — jedan tim,
                  jedna strategija, mjerljivi rezultati.
                </p>
              </div>
            </div>
            <div
              className="col-xl-5 col-lg-6 offset-xl-1 wow animated fadeInLeft"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <div className="video-popup-wrap">
                <div className="thumb">
                  <img
                    src={publicUrl + "assets/img/hero-digital-vanjsko.png"}
                    alt="Digitalni marketing i vanjsko oglašavanje — ista kampanja online i na ulici"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Video;
